export default __webpack_public_path__ + "static/media/aws.60f42842.svg";